<template>
  <svg
    width="57"
    height="56"
    viewBox="0 0 57 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3646_1788)">
      <path
        d="M40.0023 7.11328H17.0023C14.4723 7.11328 12.4023 9.18328 12.4023 11.7133V48.5133L28.5023 41.6133L44.6023 48.5133V11.7133C44.6023 9.18328 42.5323 7.11328 40.0023 7.11328ZM40.0023 41.6133L28.5023 36.5993L17.0023 41.6133V11.7133H40.0023V41.6133Z"
        fill="#383838"
      />
    </g>
    <defs>
      <clipPath id="clip0_3646_1788">
        <rect
          width="55.2"
          height="55.2"
          fill="white"
          transform="translate(0.902344 0.210938)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
